import QRCode from 'qrcodejs2'
import {mcToast,commonUrl,sendLog} from "../../../util/util"
export default {
    components: {
        
    },
    data() {
        return {
            usedFlag:0,
            showCityFlag:false,//显示城市弹框
            cityTemp:'北京',//暂存的城市
            city:'北京',//页面上显示的城市
            cityList:[],//分支列表
            unusedList:[],//未使用券列表
            usedList:[],//已使用列表
            globalId:'',
            citySlots: [
               {
               flex: 1,
               defaultIndex: 0, 
               values: [{name:"北京"}], //城市数组
               className: 'slot1',
               textAlign: 'center'
            }],
            ticketFlag:true,//有没有券
            codeFlag:false,//显示二维码弹框
        }
    },
    created() {
        var that=this;
        axios.post('/company/privilege/coupon').then(function (res) {
            for (var i = 0; i < res.data.data.branchList.length; i++) {
                var obj={'name':res.data.data.branchList[i]}
                that.cityList.push(obj);
            }
            that.city=that.cityList[0].name;
            that.cityTemp=that.cityList[0].name;
            that.citySlots[0].values=that.cityList;
            if (!res.data.data.unusedList || res.data.data.unusedList.length==0) {
                that.ticketFlag=false;
            }else{
                that.unusedList=res.data.data.unusedList;
            }
            that.globalId=res.data.data.globalId;
        });
    },
    mounted() {
        // this.qrcode()
    },
    methods: {
        // 切换未使用
        clickNotUsed(){
            this.usedFlag=0;
            this.queryTicket();
        },
        // 切换到已使用
        clickUsed(){
            this.usedFlag=1;
            this.queryTicket();
        },
        // 切换城市
        onCityChange(picker, values) {
            this.cityTemp=values[0].name
            console.log(values[0].name)
        },
        cityPickerConfirm(){
            this.showCityFlag=false;
            this.city=this.cityTemp;
            this.queryTicket();
        },
        //查询券
        queryTicket(){
            var that=this;
            axios.post('/company/privilege/coupon?queryBranch='+this.city+'&usedFlag='+this.usedFlag).then(function (res) {
                if (!res.data.data.unusedList || res.data.data.unusedList.length==0) {
                    that.ticketFlag=false;
                }else{
                    that.ticketFlag=true;
                    that.unusedList=res.data.data.unusedList;
                }
                if (res.data.data.usedList) {
                    that.usedList=res.data.data.usedList;
                }
            });
        },
        //点击礼品券
        clickTicket(obj){
            var that=this;
            sendLog("1096");
            if (obj.getMethod==1) {
                document.getElementById('qrcode').innerHTML = '';
                var str=commonUrl.webUrl+'/memberCenter/myGiftCheck?activityId='+obj.activityId+'&globalId='+this.globalId;
                that.qrcode(str);
                that.codeFlag=true;
            }else{
                this.$router.push({
                    path: '/memberCenter/myGiftTicketInput',
                    name: 'myGiftTicketInput',
                    params: {
                      activityId:obj.activityId
                  }, 
                })
            }
        },
        // 生成二维码
        qrcode (url) {
            let qrcode = new QRCode('qrcode',{
                width: 251, // 设置宽度，单位像素
                height: 251, // 设置高度，单位像素
                text: url?url:'https://www.baidu.com'   // 设置二维码内容或跳转地址
            })
        },
        goMemberGrowthRule(){
            this.$router.push({
                path: '/memberCenter/memberGrowthRule',
                name: 'memberGrowthRule',
            })
        },
    }
}